module.exports = __webpack_public_path__ + "static/media/vehiclesParked.90109152.jpg";